// extracted by mini-css-extract-plugin
export var actionText = "_r9-4";
export var container = "_r9-0";
export var leftSection = "_r9-1";
export var rightSection = "_r9-2";
export var settingsButton = "_r9-6";
export var settingsIcon = "_r9-7";
export var shortcut = "_r9-5";
export var shortcutGroup = "_r9-3";